import axios from "axios";

const DEFAULT_URL = "https://kiwe.biotinc.com";

const api = axios.create({
  baseURL: DEFAULT_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const isExistAccount = async (email) => {
  try {
    // const callUrl = `${DEFAULT_URL}/v1/account/exists?email=${email}`;
    console.log("api isExistAccount email ", email);
    const response = await api.get(`/v1/account/exists?email=${email}`);
    console.log(
      "isExistAccount url !!!!!!! 먹히고 있니? ",
      response.config.url
    );
    console.log("isExistAccount response ", response);
    return response.data;
  } catch (error) {
    console.error("Failed to call select Account API ", error.message);
    return null;
  }
};

export const deleteAccount = async (email, uid) => {
  console.log("delete account api parameter ... ", email, uid);
  try {
    await axios.delete(`${DEFAULT_URL}/v1/web/account`, {
      params: {
        email,
        accountUid: uid,
      },
    });
    console.log("Success to delete account");
  } catch (error) {
    console.error("Failed to call Delete Account API ", error.message);
  }
};
